import { Navigate, useParams } from 'react-router-dom';

/**
 * ValidatedRoute - Validates URL parameters before rendering children
 *
 * Ensures companyId and installationId (when present) are valid numeric values.
 * Redirects to a safe fallback if validation fails.
 *
 * @param {ReactNode} children - The component to render if validation passes
 * @param {boolean} requireInstallation - Whether installationId is required
 */
function ValidatedRoute({ children, requireInstallation = false }) {
    const { companyId, installationId } = useParams();

    // Validate companyId is a positive integer
    if (!companyId || !/^\d+$/.test(companyId)) {
        return <Navigate to="/login" replace />;
    }

    // Validate installationId if required or present
    if (requireInstallation && (!installationId || !/^\d+$/.test(installationId))) {
        // Missing or invalid installation ID - redirect to company about page
        return <Navigate to={`/app/company/${companyId}/about`} replace />;
    }

    // If installationId is present but invalid, redirect to company about
    if (installationId && !/^\d+$/.test(installationId)) {
        return <Navigate to={`/app/company/${companyId}/about`} replace />;
    }

    return children;
}

export default ValidatedRoute;
